const name = 'schema.yaml'
const text = `$schema: 'https://json-schema.org/draft/2020-12/schema'
title: Object
type: object
required:
  - field
properties:
  field:
    type: string
additionalProperties: false
`
const template = { name, text }
export default template
